var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test"},[_c('div',{staticClass:"right-card"},[_c('AllTemp')],1),_c('div',{staticStyle:{"clear":"both"}})])}
var staticRenderFns = []

export { render, staticRenderFns }